var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb-element"},[_c('div',{staticClass:"bto-sb-tost-notification",class:{
      'bto-sb-tost-notifications-success': _vm.message.type === 1,
      'bto-sb-tost-notifications-error': _vm.message.type === 2,
      'bto-sb-tost-notifications-info': _vm.message.type === 3,
      'bto-sb-tost-notifications-warning': _vm.message.type === 4,
      }},[_c('div',{staticClass:"bto-sb-tost-notification-title",on:{"click":function($event){return _vm.removeToast()}}},[_vm._v(" "+_vm._s(_vm.message.title)+" ")]),_c('div',{staticClass:"bto-sb-tost-notification-close",on:{"click":function($event){return _vm.removeToast()}}},[_c('i',{staticClass:"bto-app-icon bto-app-delete"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }